/**
 * Full colour support for this component is not yet done - add as required
 * Known elements not supported/tested:
 *     - selectable & expandable rows
 *     - sorting & filters
 * For all Props, structure & usage, see Antd documentation
 */
import styled from 'styled-components';

import { lighten } from 'utils/colours';
import { Table } from 'antd';

const StyledTable = styled(Table)`
    /* row selection background & radio */
    .ant-table-tbody > tr.ant-table-row-selected > td {
        background: ${({ theme }) => lighten(theme.colour.primary, 48)};
    }
    .ant-table-tbody > tr.ant-table-row-selected:hover > td {
        background: ${({ theme }) => lighten(theme.colour.primary, 45)};
    }
    .ant-table-summary {
        z-index: 0;
    }

    & .ant-radio-checked .ant-radio-inner {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    & .ant-radio-wrapper:hover .ant-radio,
    & .ant-radio:hover .ant-radio-inner,
    & .ant-radio-input:focus + .ant-radio-inner {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    & .ant-radio-checked::after {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    & .ant-radio-inner::after {
        background-color: ${({ theme }) => theme.colour.primary};
    }

    .ant-table-body {
        overflow-y: auto !important;
    }

    /* Change row hovering colour */
    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
        background: ${({ theme }) => lighten(theme.colour.primary, 45)};
    }

    /* Change pagination style & colours */
    .ant-pagination-item:focus,
    .ant-pagination-item:hover {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-item-active {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-item-active a {
        color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-item:focus a,
    .ant-pagination-item:hover a {
        color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-item-active:focus,
    .ant-pagination-item-active:hover {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    .ant-pagination-item-active:focus a,
    .ant-pagination-item-active:hover a {
        color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
        display: inline-flex;
        color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-prev:hover a,
    .ant-pagination-next:hover a {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    .ant-pagination-prev:focus .ant-pagination-item-link,
    .ant-pagination-next:focus .ant-pagination-item-link,
    .ant-pagination-prev:hover .ant-pagination-item-link,
    .ant-pagination-next:hover .ant-pagination-item-link {
        color: ${({ theme }) => theme.colour.primary};
        border-color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-options-quick-jumper input:hover {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    .ant-pagination-options-quick-jumper input:focus {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    .ant-pagination-simple .ant-pagination-simple-pager input:hover {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    .ant-pagination-prev span,
    .ant-pagination-next span {
        display: inline-flex;
    }

    .ant-table-column-sorter-up.active,
    .ant-table-column-sorter-down.active {
        color: ${({ theme }) => theme.colour.primary};
    }

    .ant-table-row-expand-icon {
        color: ${({ theme }) => theme.colour.primary};
    }

    .ant-select-focused.ant-select-multiple .ant-select-selector {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }

    .ant-select-focused.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }

    .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }

    & .ant-spin {
        color: ${({ theme }) => theme.colour.primary};
    }
    & .ant-spin-dot-item {
        background-color: ${({ theme }) => theme.colour.primary};
    }
`;

StyledTable.Column = Table.Column;
StyledTable.ColumnGroup = Table.ColumnGroup;

export default StyledTable;
